import React, {Component} from 'react';
import './container_m.css';

class LichtContainer_m extends Component {
    state = {}

    useMe = () => {
        
    }

    render() {
        const {component: C, ...props} = this.props
        return (
                <div className="lichtcontainer_m">
                <C {...props} />
            </div>
        )
    }
}

export function withContainer(component) {
    return function(props) {
        return (
            <LichtContainer_m component={component} {...props}/>
        )
    }
}